// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__c6W7k","open":"loader_open__hCFlj","content":"loader_content__xh9D9","close":"loader_close__TMDn5"};